import { ApiManager } from '../../core/api-manager';
import { DataManager } from '../../core/data-manager';
import { settings } from '../../config/settings';
import { LanguageProvider } from '../../core/language-provider';
import { toast } from 'react-toastify';



export async function preDelete(entity, id) {

    // Impedisce l'eliminazione di customer_offer se ci sono righe
    if (entity === 'customer_offer') {
        const response = await DataManager.getItemSimple('customer_offer', id);

        if (response.success === 1) {
            const offer = response.body[0];

            // Controlla se ci sono righe nell'offerta
            if (offer.rows && offer.rows > 0) {
                toast.error('Impossibile eliminare l\'offerta: sono presenti ' + offer.rows + ' righe. Elimina prima tutte le righe.', { theme: 'colored' });
                return {
                    success: 0,
                    message: 'L\'offerta contiene righe e non può essere eliminata.'
                };
            }
        }
    }

    // Impedisce l'eliminazione di customer_order se ci sono righe
    if (entity === 'customer_order') {
        const response = await DataManager.getItemSimple('customer_order', id);

        if (response.success === 1) {
            const order = response.body[0];

            // Controlla se ci sono righe nell'ordine
            if (order.rows && order.rows > 0) {
                toast.error('Impossibile eliminare l\'ordine cliente: sono presenti ' + order.rows + ' righe. Elimina prima tutte le righe.', { theme: 'colored' });
                return {
                    success: 0,
                    message: 'L\'ordine cliente contiene righe e non può essere eliminato.'
                };
            }
        }
    }

    // Impedisce l'eliminazione di supplier_order se ci sono righe
    if (entity === 'supplier_order') {
        const response = await DataManager.getItemSimple('supplier_order', id);

        if (response.success === 1) {
            const order = response.body[0];

            // Controlla se ci sono righe nell'ordine
            if (order.rows && order.rows > 0) {
                toast.error('Impossibile eliminare l\'ordine fornitore: sono presenti ' + order.rows + ' righe. Elimina prima tutte le righe.', { theme: 'colored' });
                return {
                    success: 0,
                    message: 'L\'ordine fornitore contiene righe e non può essere eliminato.'
                };
            }
        }
    }

    // Impedisce l'eliminazione di supplier_transport_document se lo stato è Scaricato
    if (entity === 'supplier_transport_document') {
        const response = await DataManager.getItemSimple('supplier_transport_document', id);

        if (response.success === 1) {
            const ddt = response.body[0];

            // Controlla se lo stato è Scaricato
            if (ddt.status && ddt.status?.value === '20_UNLOADED') {
                toast.error('Impossibile eliminare il DDT fornitore: il documento è già stato scaricato.', { theme: 'colored' });
                return {
                    success: 0,
                    message: 'Il DDT fornitore scaricato non può essere eliminato.'
                };
            }
        }
    }

    // Impedisce l'eliminazione di customer_ddt se lo stato è diverso da 0_PENDING
    if (entity === 'customer_ddt') {
        const response = await DataManager.getItemSimple('customer_ddt', id);

        if (response.success === 1) {
            const ddt = response.body[0];

            // Controlla se lo stato è diverso da 0_PENDING
            if (ddt.status && ddt.status?.value !== '0_PENDING') {
                toast.error('Impossibile eliminare il DDT cliente: lo stato deve essere "In attesa" per poter eliminare il documento.', { theme: 'colored' });
                return {
                    success: 0,
                    message: 'Il DDT cliente può essere eliminato solo se lo stato è 0_PENDING.'
                };
            }
        }
    }

    // Impedisce l'eliminazione di customer_invoices se lo stato è diverso da 0_PENDING
    if (entity === 'customer_invoices') {
        const response = await DataManager.getItemSimple('customer_invoices', id);

        if (response.success === 1) {
            const invoice = response.body[0];

            // Controlla se lo stato è diverso da 0_PENDING
            if (invoice.status && invoice.status?.value !== '0_PENDING') {
                toast.error('Impossibile eliminare la fattura cliente: lo stato deve essere "In attesa" per poter eliminare il documento.', { theme: 'colored' });
                return {
                    success: 0,
                    message: 'La fattura cliente può essere eliminata solo se lo stato è 0_PENDING.'
                };
            }
        }
    }

    return {
        success: 1,
        message: ''
    }
}